import {Screen} from './Screen'

export const Activity = () => {
  return <Screen />
}
